import { render, staticRenderFns } from "./FAQManagementModify.vue?vue&type=template&id=2ed1d328&scoped=true"
import script from "./FAQManagementModify.vue?vue&type=script&lang=js"
export * from "./FAQManagementModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1d328",
  null
  
)

export default component.exports